export default __webpack_public_path__ + "static/media/cross.a7775cc5.svg";